import React, { Component } from 'react';
import MarcaItem from './MarcaItem';

export default class Marca extends Component {
    render() {

        const { edicion, selectedAdministrator } = this.props.data;

        return (
            <div className="row top-separator-xs">
                {this.props.data.GET_ADMINISTRADORA.map(d => {
                    const classeDisabled = `container-radio${(d.Activo == 1 && (!edicion || (edicion && selectedAdministrator == d.Abreviatura))) ? '' : '-disabled'} radio-margin`;
                    return (
                        <div>
                            <MarcaItem
                                esEdicion={this.props.data.ProductoId>0 || this.props.data.ProductoCabalId>0 || this.props.data.ProductoVisaId}
                                clase={classeDisabled}
                                key={d.Id}
                                id={d.Id}
                                descripcion={d.Descripcion}
                                abreviatura={d.Abreviatura}
                                checked={selectedAdministrator == d.Abreviatura}
                                getDataByAdministratorId={() => {
                                    if (d.Activo) {
                                        this.props.getDataByAdministratorId(d.Id, d.Abreviatura)
                                    }
                                }}
                            />
                        </div>
                    )
                })}
            </div>
        );
    }
}